<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>
<ng-template #lazyLoadPanelContent>
  <hs-single-account-selected
    [content]="selectedAccountDependentContent"
    (accountIdChange)="accountId$.next($event)"
  ></hs-single-account-selected>
</ng-template>

<ng-template #selectedAccountDependentContent>
  <div class="d-flex flex-column w-100 h-100">
    <hs-external-file-manager-header
      [accountId]="accountId$ | async"
      [reconDate]="reconDate$ | async"
      (selectedDateChange)="selectedDate$.next($event)"
    ></hs-external-file-manager-header>

    <div *nfLoader="isLoading$ | async" class="d-flex flex-column w-100 h-100">
      <hs-no-executions-available
        [content]="executionsAvailableContent"
        [isEmpty]="uiNodes.length === 0"
      >
      </hs-no-executions-available>
    </div>
  </div>
</ng-template>

<ng-template #executionsAvailableContent>
  <ng-container *ngIf="uiNodes$ | async as uiNodes">
    <div class="nodes-table-container" #nodesTable>
      <hs-nodes-explorer
        #nodesExplorer
        id="nodes-explorer"
        [uiNodes]="uiNodes"
        [savedViews]="savedViewsState$ | async"
        (selectedExecutionChange)="onExecutionNumberChange($event)"
        (activateEvent)="onActivateEvent($event)"
        (inactivateEvent)="onInactivateEvent($event)"
      >
      </hs-nodes-explorer>
    </div>
    <ng-container *ngIf="executionNumber$ | async as executionNumber">
      <hs-resize-handle
        [elem1]="nodesTable"
        [elem2]="subPanels"
        [initialResizeHandleState]="state?.resizeHandleState"
        (resizeFinished)="onResizeFinished($event)"
      ></hs-resize-handle>
      <div id="external-file-manager-subpanels" #subPanels>
        <ul
          ngbNav
          #nav="ngbNav"
          #subPanelsNav="ngbNav"
          class="nav-tabs"
          [activeId]="activeTab"
          (activeIdChange)="onActiveTabChange($event)"
        >
          <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a
              class="external-file-manager-nav-item align-self-start"
              ngbNavLink
              >Positions</a
            >
            <ng-template ngbNavContent>
              <hs-positions-grid
                #positionsGrid
                [savedViews]="savedViewsState$ | async"
                [data]="positions$ | async"
              ></hs-positions-grid>
            </ng-template>
          </li>
          <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a
              class="external-file-manager-nav-item align-self-start"
              ngbNavLink
              >Transactions</a
            >
            <ng-template ngbNavContent>
              <hs-transactions-grid
                #transactionsGrid
                [savedViews]="savedViewsState$ | async"
                [data]="transactions$ | async"
              ></hs-transactions-grid>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
